/**
 * 主要解决计算精度的问题
 */

import Big from 'big.js'

// 加
export function add(value1: number, ...values: number[]): number {
  return values
    .reduce((bigInstance, v) => bigInstance.plus(v), Big(value1))
    .toNumber()
}

// 减
export function minus(value1: number, value2: number): number {
  return Big(value1).minus(value2).toNumber()
}

// 乘
export function times(value1: number, value2: number): number {
  return Big(value1).times(value2).toNumber()
}

// 除
export function divide(value1: number, value2: number): number {
  return Big(value1).div(value2).toNumber()
}
